"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  MultiComboBoxToken: true
};
exports.default = exports.MultiComboBoxToken = void 0;
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Icon = require("../Icon/Icon");
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _MultiComboBoxToken = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MultiComboBoxToken.css") : void 0);
var _MultiComboBoxToken2 = require("./_MultiComboBoxToken.types");
Object.keys(_MultiComboBoxToken2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _MultiComboBoxToken2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MultiComboBoxToken2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-multicombobox-token';
/**
 * A Token may be used to represent contextualizing information.
 * For example, they can be useful to show applied filters,
 * selected values for form field, or object metadata.
 */
const MultiComboBoxToken = exports.MultiComboBoxToken = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(MultiComboBoxToken, _props)) : _props;
  const {
      closeLabel,
      className,
      children,
      closeClassName,
      closeProps,
      disabled,
      onKeyDown,
      onClick,
      readOnly,
      removeClassName,
      removeLabel,
      removeProps,
      selected,
      overflow,
      textClassName,
      textProps,
      validationMessageState
    } = props,
    otherProps = __rest(props, ["closeLabel", "className", "children", "closeClassName", "closeProps", "disabled", "onKeyDown", "onClick", "readOnly", "removeClassName", "removeLabel", "removeProps", "selected", "overflow", "textClassName", "textProps", "validationMessageState"]);
  const classnames = _bind.default.bind(_MultiComboBoxToken.default);
  const handleOnClick = e => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }
  };
  const handleKeyDown = e => {
    switch (e.keyCode) {
      case _keycode.default.codes.enter:
        handleOnClick(e);
        break;
      case _keycode.default.codes.space:
        e.preventDefault();
        handleOnClick(e);
        break;
      default:
        break;
    }
  };
  const classes = classnames(CSS_BLOCK, {
    [`${CSS_BLOCK}--selected`]: selected,
    [`${CSS_BLOCK}--readonly`]: readOnly,
    [`${CSS_BLOCK}--disabled`]: disabled,
    [`${CSS_BLOCK}--overflow`]: overflow,
    [`${CSS_BLOCK}--${validationMessageState}`]: overflow && validationMessageState
  }, className);
  const textClasses = classnames(`${CSS_BLOCK}__text`, textClassName, textProps === null || textProps === void 0 ? void 0 : textProps.className);
  const iconClasses = classnames(`${CSS_BLOCK}__close`, removeClassName || closeClassName, (removeProps === null || removeProps === void 0 ? void 0 : removeProps.className) || (closeProps === null || closeProps === void 0 ? void 0 : closeProps.className));
  return /*#__PURE__*/_react.default.createElement("span", Object.assign({
    role: "button",
    tabIndex: disabled ? -1 : 0
  }, otherProps, {
    className: classes,
    onClick: handleOnClick,
    onFocus: e => {
      var _a;
      if (disabled) {
        (_a = e.target) === null || _a === void 0 ? void 0 : _a.blur();
      }
    },
    onKeyDown: (0, _chainFunction.default)(handleKeyDown, onKeyDown),
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("span", Object.assign({}, textProps, {
    className: textClasses
  }), children), !readOnly && !overflow && (/*#__PURE__*/_react.default.createElement("span", Object.assign({}, removeProps || closeProps, {
    className: iconClasses,
    role: "presentation"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    ariaLabel: removeLabel || closeLabel,
    iconName: "close",
    size: "xs"
  }))));
});
MultiComboBoxToken.displayName = 'MultiComboBoxToken';
var _default = exports.default = MultiComboBoxToken;